export default ({
  cloudName,
  preset,
  file,
  onProgress,
}) => (
  new Promise((resolve, reject) => {
    let timeoutFn;
    const url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`;
    const xhr = new XMLHttpRequest();
    const fd = new FormData();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    const cancelTimeout = () => timeoutFn && clearTimeout(timeoutFn);
    const simulateTo100 = () => {
      let simulatedProgress = 80;
      let delay = 0;
      const moveProgressBar = () => {
        timeoutFn = setTimeout(() => {
          const increment = Math.random() * 5;
          simulatedProgress = Math.max(simulatedProgress += increment, 100);
          delay += 500;
          onProgress({ progress: Math.round(simulatedProgress) });
          if (simulatedProgress === 100) {
            cancelTimeout();
          } else {
            moveProgressBar(delay + 500);
          }
        }, delay);
      };
      moveProgressBar(simulatedProgress);
    };
    xhr.upload.addEventListener('progress', (e) => {
      const progress = Math.round((e.loaded * 80.0) / e.total);
      if (onProgress && (typeof onProgress === 'function')) {
        if (progress === 80) {
          simulateTo100();
        } else {
          onProgress({ progress });
        }
      }
    });
    xhr.upload.addEventListener('error', (e) => {
      reject(e);
    });
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          resolve(response);
        } else {
          cancelTimeout();
          const response = JSON.parse(xhr.responseText);
          const error = (response && response.error) || new Error({
            message: 'Server error',
          });
          reject(error);
        }
      }
    };
    fd.append('upload_preset', preset);
    fd.append('tags', 'browser_upload');
    fd.append('file', file);
    xhr.send(fd);
  })
);
